import type { RouteRecordRaw } from 'vue-router';
import DefaultLayout from '@/layouts/DefaultLayout.vue';

export const notificationRoutes: RouteRecordRaw[] = [
  {
    path: '/notifications',
    name: 'notifications',
    meta: { layout: DefaultLayout },
    component: () => import('@/pages/Notifications/NotificationsPage.vue'),
  },
  {
    // Target of notification email links: loads the notification and redirects to the right
    // page client-side via the shared notificationRouteMap, so the backend never builds FE URLs.
    path: '/notifications/:notificationId/resolve',
    name: 'notification-resolve',
    meta: { layout: DefaultLayout },
    component: () => import('@/pages/Notifications/NotificationResolvePage.vue'),
  },
];
